import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import { GET_AI_SETTINGS } from "views/Account/Settings/AI/gql";

import useChatStore from "../store/useStore";
import { ChatMode } from "../types";

const useAvailableChatModes = () => {
  const { data } = useQuery<{ infraAssistantBuildModeEnabled: boolean }>(GET_AI_SETTINGS, {
    fetchPolicy: "cache-and-network",
  });

  const buildModeEnabled = !!data?.infraAssistantBuildModeEnabled;

  const currentMode = useChatStore((state) => state.mode);
  const setMode = useChatStore((state) => state.setMode);

  useEffect(() => {
    if (currentMode === ChatMode.BUILD && !buildModeEnabled) {
      setMode(ChatMode.ASK);
    }
  }, [buildModeEnabled, currentMode, setMode]);

  return { buildModeEnabled };
};

export default useAvailableChatModes;
